<template>
  <div class="fault-view">
    <div class="top-view">
      <!-- <div>故障统计</div> -->
      <el-form :inline="true" :model="searchForm">
        <el-form-item>
          <el-cascader v-model="searchForm.cs" :placeholder="$t('public.name1')" :options="shlist"/>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.shlx" :placeholder="$t('public.name2')">
            <el-option :label="$t('faultStats.name1')" value="1"></el-option>
            <el-option :label="$t('faultStats.name2')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSearch">{{ $t('public.name3') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content-view">
      <div class="total-view">
        <div class="total-item">
          <div class="total-item-label">{{ $t('faultStats.name3') }}</div>
          <div><span class="num">{{totalInfo.dayTotal}}</span> {{ $t('faultStats.name4') }} <span class="small-num">{{totalInfo.yesTotal}}</span></div>
        </div>
        <div class="total-item">
          <div class="total-item-label">{{ $t('faultStats.name5') }}<i class="el-icon-question" /></div>
          <div class="num">{{totalInfo.TB}}%</div>
        </div>
        <div class="total-item">
          <div class="total-item-label">{{ $t('faultStats.name6') }}</div>
          <div class="num">{{totalInfo.total}}</div>
        </div>
      </div>
      <div class="total-chart-view">
        <div class="total-chart-top">
          <div class="total-chart-title">{{ $t('faultStats.name7') }} <i class="el-icon-question" /></div>
          <el-date-picker
            v-model="times"
            type="daterange"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
            value-format="yyyy-MM-dd"
          />
        </div>
        <div class="total-chart" ref="lineChart"></div>
      </div>
      <div class="total-chart-view">
        <div class=""></div>
        <div class="type-chart" ref="typeChart"></div>
      </div>
    </div>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userinfo']),
    shlist () {
      return [
        {
          value: 'zhinan',
          label: this.$t('faultStats.name8'),
          children: [
            { value: 'shejiyuanze', label: this.$t('faultStats.name9') },
            { value: 'shejiyuanze', label: this.$t('faultStats.name10') }
          ]
        }
      ]
    }
  },
  components: {
  },
  data() {
    return {
      searchForm: {
        cs: '',
        shlx: ''
      },

      totalInfo: {
        dayTotal: 0,
        yesTotal: 0,
        TB: 100,
        total: 28
      },
      times: [],
      lineChart: null,
      pieChart: null
    }
  },
  created() {
    this.initAccountDateRange()
    this.$bus.$on('lang', this.refreshChartsOnLangChange)
    this.$bus.$on('accountTimeZoneChanged', this.initAccountDateRange)
  },
  beforeDestroy() {
    this.$bus.$off('lang', this.refreshChartsOnLangChange)
    this.$bus.$off('accountTimeZoneChanged', this.initAccountDateRange)
  },
  mounted() {
    this.getList()
    this.lineChart = this.$echarts.init(this.$refs.lineChart, null, { renderer: 'svg' })
    this.pieChart = this.$echarts.init(this.$refs.typeChart, null, { renderer: 'svg' })
    this.$nextTick(() => {
      this.setLineOption()
      this.setPieOption()
    })
  },
  methods: {
    refreshChartsOnLangChange() {
      if (this.lineChart) {
        this.setLineOption()
      }
      if (this.pieChart) {
        this.setPieOption()
      }
    },
    initAccountDateRange() {
      const end = this.$tz.accountNow()
      const start = end.clone().subtract(6, 'days')
      this.times = [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')]
    },
    onSearch() {

    },
    getList() {

    },
    setLineOption() {
      const option = {
        xAxis: {
          type: 'category',
          data: ['2025.02.14', '2025.02.15', '2025.02.16', '2025.02.17', '2025.02.18', '2025.02.19', '2025.02.20']
        },
        yAxis: {
          type: 'value',
          name: this.$t('faultStats.name11'),
          nameTextStyle: {
            fontSize: 14,
            align: 'right',
            color: '#0f73e6',
            borderColor: '#0f73e6',
            borderWidth: 1,
            padding: [5, 10],
            borderRadius: 3
          }
        },
        legend: {
          bottom: 0
        },
        grid: {
          top: 50,
          left: 35,
          bottom: 25,
          right: 15,
          containLabel: true
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              title: this.$t('faultStats.name12')
            }
          }
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],
            type: 'line',
            name: this.$t('faultStats.name11'),
            symbol: 'circle'
          }
        ]
      }
      this.lineChart.setOption(option)
    },
    setPieOption() {
      const option = {
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              title: this.$t('faultStats.name12')
            }
          }
        },
        title: {
          text: this.$t('faultStats.name13'),
          left: 0,
          borderColor: '#0f73e6',
          borderWidth: 1,
          padding: [5, 10],
          borderRadius: 3,
          textStyle: {
            fontSize: 14,
            color: '#0f73e6'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          width: '50%',
          left: 'center',
          top: 30,
          itemStyle: {
            fontSize: 12
          },
          data: [
            this.$t('faultStats.name14'),
            this.$t('faultStats.name15'),
            this.$t('faultStats.name16'),
            this.$t('faultStats.name17'),
            this.$t('faultStats.name18'),
            this.$t('faultStats.name19'),
            this.$t('faultStats.name20'),
            this.$t('faultStats.name21'),
            this.$t('faultStats.name22'),
            this.$t('faultStats.name23')
          ]
        },
        series: [
          {
            type: 'pie',
            selectedMode: 'single',
            radius: [0, '30%'],
            center: ['50%', '65%'],
            label: {
              position: 'inner',
              fontSize: 14
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 1548, name: this.$t('faultStats.name16') },
              { value: 775, name: this.$t('faultStats.name14') },
              { value: 679, name: this.$t('faultStats.name15'), selected: true }
            ]
          },
          {
            type: 'pie',
            radius: ['45%', '60%'],
            center: ['50%', '65%'],
            avoidLabelOverlap: true,
            labelLine: {
              length: 30
            },
            label: {
              formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
              backgroundColor: '#F6F8FC',
              borderColor: '#8C8D8E',
              borderWidth: 1,
              borderRadius: 4,
              rich: {
                a: {
                  color: '#6E7079',
                  lineHeight: 22,
                  align: 'center'
                },
                hr: {
                  borderColor: '#8C8D8E',
                  width: '100%',
                  borderWidth: 1,
                  height: 0
                },
                b: {
                  color: '#4C5058',
                  fontSize: 14,
                  fontWeight: 'bold',
                  lineHeight: 33
                },
                per: {
                  color: '#fff',
                  backgroundColor: '#4C5058',
                  padding: [3, 4],
                  borderRadius: 4
                }
              }
            },
            data: [
              { value: 1048, name: this.$t('faultStats.name16') },
              { value: 735, name: this.$t('faultStats.name14') },
              { value: 580, name: this.$t('faultStats.name17') },
              { value: 484, name: this.$t('faultStats.name18') },
              { value: 300, name: this.$t('faultStats.name19') }
            ]
          }
        ]
      }
      this.pieChart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.fault-view {
  background: rgba(255,255,255,0.1);
  .top-view {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .content-view {
    padding: 15px;
    background: #fff;
    .total-view {
      width: 100%;
      height: 80px;
      border: 1px solid #eee;
      border-radius: 4px;
      display: flex;
      align-items: center;
      .total-item {
        width: 33.3%;
        padding-left: 30px;
        border-left: 1px solid #eee;
        &:first-child {
          border-left: 0;
        }
        &-label {
          color: #555;
          font-size: 12px;
          margin-bottom: 10px;
          i {
            margin-left: 5px;
          }
        }
        .num {
          font-size: 15px;
          font-weight: bold;
        }
      }
    }
    .total-chart-view {
      margin-bottom: 15px;
      .total-chart-top {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .total-chart-title {
        font-weight: bold;
        color: #333;
        padding: 12px 0;
      }
      .total-chart {
        width: 100%;
        height: 300px;
      }
      .type-chart {
        width: 100%;
        height: 500px;
      }
    }
  }

}
</style>
